//
//    WARNING
//    This file was auto-generated by swagger-typescript-codegen.
//    Please do not make changes here because they may be overwritten.
//

import request from 'superagent';
import {
  CallbackHandler,
  CommonRequestOptions,
  ConfigureAgentHandler,
  ConfigureRequestHandler,
  InsightServicesResponseWrapper,
  Logger,
  QueryParameters,
  RequestHeaders,
  RequestHeadersHandler,
  ResponseWithBody,
} from './types';

export type Application = {
  defaultPermissions?: Array<PermissionSet>;
  id?: string;
  isService?: boolean;
  name?: string;
  permissions?: Array<Permission>;
  policies?: Array<Policy>;
  protectedProperties?: Array<ProtectedProperty>;
  redirectURLs?: Array<string>;
  rolePermissions?: Array<RolePermission>;
  roles?: Array<Role>;
  landingPageURL?: string;
};

export type ApplicationPermissionSet = {
  applicationId?: string;
  applicationName?: string;
  permissions?: Array<string>;
};

export type AuthorizationClient = {
  attributes?: {} & {
    [key: string]: string;
  };
  clientId?: string;
};

export type AuthorizationResponse = {
  insightClaims?: string;
};

export type AuthorizationUser = {
  clients?: Array<AuthorizationClient>;
  displayName?: string;
  email?: string;
  firstName?: string;
  id?: string;
  lastName?: string;
};

export type Client = {
  applications?: Array<Application>;
  attributes?: Array<ClientAttribute>;
  clientName?: string;
  id?: string;
};

export type ClientAttribute = {
  description?: string;
  id?: string;
  name?: string;
};

export type ClientAttributeValue = {
  description?: string;
  id?: string;
  name?: string;
  value?: string;
};

export type IFilter = {};

export type Permission = {
  description?: string;
  id?: string;
  label?: string;
};

export type PermissionRequest = {
  applicationId?: string;
  permission?: string;
  userId?: string;
};

export type PermissionSet = {
  applicationId?: string;
  applicationName?: string;
  permissions?: Array<Permission>;
  roles?: Array<Role>;
};

export type Policy = {
  definition?: IFilter;
  name?: string;
  operation?: Array<string>;
  serviceId?: string;
};

export type ProtectedOperation = {
  operationType?: string;
  permissions?: Array<string>;
};

export type ProtectedProperty = {
  documentType?: string;
  id?: string;
  operations?: Array<ProtectedOperation>;
  propertyName?: string;
  serviceId?: string;
};

export type Role = {
  description?: string;
  id?: string;
  label?: string;
};

export type RolePermission = {
  permissions?: Array<Permission>;
  role?: Role;
};

export type UserDTO = {
  displayName?: string;
  email?: string;
  firstName?: string;
  id?: string;
  lastName?: string;
  password?: string;
};

export type UserPermission = {
  applicationId?: string;
  id?: string;
  isService?: boolean;
  name?: string;
  permissions?: Array<Permission>;
  policies?: Array<Policy>;
  roles?: Array<Role>;
  userId?: string;
};

export type MvcProblemDetails = {
  detail?: string;
  instance?: string;
  status?: number;
  title?: string;
  type?: string;
} & {
  [key: string]: {} & {
    [key: string]: any;
  };
};

export type GraphAddIn = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  id?: string;
  oDataType?: string;
  properties?: Array<GraphKeyValue>;
  type?: string;
};

export type GraphApiApplication = {
  acceptMappedClaims?: boolean;
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  knownClientApplications?: Array<string>;
  oDataType?: string;
  oauth2PermissionScopes?: Array<GraphPermissionScope>;
  preAuthorizedApplications?: Array<GraphPreAuthorizedApplication>;
  requestedAccessTokenVersion?: number;
};

export type GraphAppRole = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  allowedMemberTypes?: Array<string>;
  description?: string;
  displayName?: string;
  id?: string;
  isEnabled?: boolean;
  oDataType?: string;
  origin?: string;
  value?: string;
};

export type GraphApplication = {
  info?: GraphInformationalUrl;
  tags?: Array<string>;
  addIns?: Array<GraphAddIn>;
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  api?: GraphApiApplication;
  appId?: string;
  appRoles?: Array<GraphAppRole>;
  applicationTemplateId?: string;
  createdDateTime?: string;
  createdOnBehalfOf?: GraphDirectoryObject;
  deletedDateTime?: string;
  description?: string;
  displayName?: string;
  extensionProperties?: Array<GraphExtensionProperty>;
  groupMembershipClaims?: string;
  homeRealmDiscoveryPolicies?: Array<GraphHomeRealmDiscoveryPolicy>;
  id?: string;
  identifierUris?: Array<string>;
  isDeviceOnlyAuthSupported?: boolean;
  isFallbackPublicClient?: boolean;
  keyCredentials?: Array<GraphKeyCredential>;
  logo?: IOStream;
  notes?: string;
  oDataType?: string;
  oauth2RequirePostResponse?: boolean;
  optionalClaims?: GraphOptionalClaims;
  owners?: Array<GraphDirectoryObject>;
  parentalControlSettings?: GraphParentalControlSettings;
  passwordCredentials?: Array<GraphPasswordCredential>;
  publicClient?: GraphPublicClientApplication;
  publisherDomain?: string;
  requiredResourceAccess?: Array<GraphRequiredResourceAccess>;
  signInAudience?: string;
  spa?: GraphSpaApplication;
  tokenEncryptionKeyId?: string;
  tokenIssuancePolicies?: Array<GraphTokenIssuancePolicy>;
  tokenLifetimePolicies?: Array<GraphTokenLifetimePolicy>;
  web?: GraphWebApplication;
};

export type GraphDirectoryObject = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  deletedDateTime?: string;
  id?: string;
  oDataType?: string;
};

export type GraphExtensionProperty = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  appDisplayName?: string;
  dataType?: string;
  deletedDateTime?: string;
  id?: string;
  isSyncedFromOnPremises?: boolean;
  name?: string;
  oDataType?: string;
  targetObjects?: Array<string>;
};

export type GraphHomeRealmDiscoveryPolicy = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  appliesTo?: Array<GraphDirectoryObject>;
  definition?: Array<string>;
  deletedDateTime?: string;
  description?: string;
  displayName?: string;
  id?: string;
  isOrganizationDefault?: boolean;
  oDataType?: string;
};

export type GraphImplicitGrantSettings = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  enableAccessTokenIssuance?: boolean;
  enableIdTokenIssuance?: boolean;
  oDataType?: string;
};

export type GraphInformationalUrl = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  logoUrl?: string;
  marketingUrl?: string;
  oDataType?: string;
  privacyStatementUrl?: string;
  supportUrl?: string;
  termsOfServiceUrl?: string;
};

export type GraphKeyCredential = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  customKeyIdentifier?: string;
  displayName?: string;
  endDateTime?: string;
  key?: string;
  keyId?: string;
  oDataType?: string;
  startDateTime?: string;
  type?: string;
  usage?: string;
};

export type GraphKeyValue = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  key?: string;
  oDataType?: string;
  value?: string;
};

export type GraphOptionalClaim = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  additionalProperties?: Array<string>;
  essential?: boolean;
  name?: string;
  oDataType?: string;
  source?: string;
};

export type GraphOptionalClaims = {
  accessToken?: Array<GraphOptionalClaim>;
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  idToken?: Array<GraphOptionalClaim>;
  oDataType?: string;
  saml2Token?: Array<GraphOptionalClaim>;
};

export type GraphParentalControlSettings = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  countriesBlockedForMinors?: Array<string>;
  legalAgeGroupRule?: string;
  oDataType?: string;
};

export type GraphPasswordCredential = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  customKeyIdentifier?: string;
  displayName?: string;
  endDateTime?: string;
  hint?: string;
  keyId?: string;
  oDataType?: string;
  secretText?: string;
  startDateTime?: string;
};

export type GraphPermissionScope = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  adminConsentDescription?: string;
  adminConsentDisplayName?: string;
  id?: string;
  isEnabled?: boolean;
  oDataType?: string;
  origin?: string;
  type?: string;
  userConsentDescription?: string;
  userConsentDisplayName?: string;
  value?: string;
};

export type GraphPreAuthorizedApplication = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  appId?: string;
  delegatedPermissionIds?: Array<string>;
  oDataType?: string;
};

export type GraphPublicClientApplication = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  oDataType?: string;
  redirectUris?: Array<string>;
};

export type GraphRequiredResourceAccess = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  oDataType?: string;
  resourceAccess?: Array<GraphResourceAccess>;
  resourceAppId?: string;
};

export type GraphResourceAccess = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  id?: string;
  oDataType?: string;
  type?: string;
};

export type GraphSpaApplication = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  oDataType?: string;
  redirectUris?: Array<string>;
};

export type GraphTokenIssuancePolicy = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  appliesTo?: Array<GraphDirectoryObject>;
  definition?: Array<string>;
  deletedDateTime?: string;
  description?: string;
  displayName?: string;
  id?: string;
  isOrganizationDefault?: boolean;
  oDataType?: string;
};

export type GraphTokenLifetimePolicy = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  appliesTo?: Array<GraphDirectoryObject>;
  definition?: Array<string>;
  deletedDateTime?: string;
  description?: string;
  displayName?: string;
  id?: string;
  isOrganizationDefault?: boolean;
  oDataType?: string;
};

export type GraphWebApplication = {
  additionalData?: {} & {
    [key: string]: {} & {
      [key: string]: any;
    };
  };
  homePageUrl?: string;
  implicitGrantSettings?: GraphImplicitGrantSettings;
  logoutUrl?: string;
  oDataType?: string;
  redirectUris?: Array<string>;
};

export type IOStream = {
  canRead?: boolean;
  canSeek?: boolean;
  canTimeout?: boolean;
  canWrite?: boolean;
  length?: number;
  position?: number;
  readTimeout?: number;
  writeTimeout?: number;
};

export type Response_getAuthPermissionsUsersByUserIdApplicationsByApplicationIdPolicies_200 = Array<Policy>;

export type Response_getAuthPermissionsUsersByUserIdApplicationsByApplicationIdRoles_200 = Array<string>;

/**
 * Insight2Profit AuthenticationService
 * @class AuthService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class AuthService {
  private domain: string = '';
  private errorHandlers: CallbackHandler[] = [];
  private requestHeadersHandler?: RequestHeadersHandler;
  private configureAgentHandler?: ConfigureAgentHandler;
  private configureRequestHandler?: ConfigureRequestHandler;

  constructor(domain?: string, private logger?: Logger) {
    if (domain) {
      this.domain = domain;
    }
  }

  getDomain() {
    return this.domain;
  }

  addErrorHandler(handler: CallbackHandler) {
    this.errorHandlers.push(handler);
  }

  setRequestHeadersHandler(handler: RequestHeadersHandler) {
    this.requestHeadersHandler = handler;
  }

  setConfigureAgentHandler(handler: ConfigureAgentHandler) {
    this.configureAgentHandler = handler;
  }

  setConfigureRequestHandler(handler: ConfigureRequestHandler) {
    this.configureRequestHandler = handler;
  }

  private request(
    method: string,
    url: string,
    body: any,
    headers: RequestHeaders,
    queryParameters: QueryParameters,
    form: any,
    reject: CallbackHandler,
    resolve: CallbackHandler,
    opts: CommonRequestOptions
  ) {
    if (this.logger) {
      this.logger.log(`Call ${method} ${url}`);
    }

    const agent = this.configureAgentHandler ? this.configureAgentHandler(request) : request;

    let req = agent(method, url);
    if (this.configureRequestHandler) {
      req = this.configureRequestHandler(req);
    }

    req = req.query(queryParameters);

    if (body) {
      headers['Content-Type'] = 'application/json';
      req.send(body);
    }

    headers['x-insight-ns'] = 'master';

    if (Object.keys(form).length > 0) {
      req.type('form');
      req.send(form);
    }

    if (this.requestHeadersHandler) {
      headers = this.requestHeadersHandler({
        ...headers,
      });
    }

    req.set(headers);

    if (opts.$retries && opts.$retries > 0) {
      req.retry(opts.$retries);
    }

    if ((opts.$timeout && opts.$timeout > 0) || (opts.$deadline && opts.$deadline > 0)) {
      req.timeout({
        deadline: opts.$deadline,
        response: opts.$timeout,
      });
    }

    req.end((error, response) => {
      // an error will also be emitted for a 4xx and 5xx status code
      // the error object will then have error.status and error.response fields
      // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
      if (error) {
        reject(error);
        this.errorHandlers.forEach((handler) => handler(error));
      } else {
        resolve(response);
      }
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthApplications
   * @description /auth/applications
   * @param {boolean} showServices - Insight2Profit AuthenticationService
   */
  getAuthApplications(
    parameters: {
      showServices?: boolean;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Array<Application>>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      if (parameters['showServices'] !== undefined) {
        queryParameters['ShowServices'] = parameters['showServices'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthApplications
   * @description /auth/applications
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthApplications(
    parameters: {
      body?: Application;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthApplicationsByApplicationId
   * @description /auth/applications/{applicationId}
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthApplicationsByApplicationId(
    parameters: {
      applicationId: string;
      body?: Application;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#putAuthApplicationsByApplicationId
   * @description /auth/applications/{applicationId}
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  putAuthApplicationsByApplicationId(
    parameters: {
      applicationId: string;
      body?: Application;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthApplicationsByApplicationIdDefaultpermissions
   * @description /auth/applications/{applicationId}/defaultpermissions
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthApplicationsByApplicationIdDefaultpermissions(
    parameters: {
      applicationId: string;
      body?: PermissionSet;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/defaultpermissions';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthApplicationsByApplicationIdDefaultpermissionsByPermissionAppId
   * @description /auth/applications/{applicationId}/defaultpermissions/{permissionAppId}
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {string} permissionAppId - Insight2Profit AuthenticationService
   */
  deleteAuthApplicationsByApplicationIdDefaultpermissionsByPermissionAppId(
    parameters: {
      applicationId: string;
      permissionAppId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Application>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/defaultpermissions/{permissionAppId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      path = path.replace('{permissionAppId}', `${parameters['permissionAppId']}`);

      if (parameters['permissionAppId'] === undefined) {
        reject(new Error('Missing required  parameter: permissionAppId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#putAuthApplicationsByApplicationIdDefaultpermissionsByPermissionAppId
   * @description /auth/applications/{applicationId}/defaultpermissions/{permissionAppId}
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {string} permissionAppId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  putAuthApplicationsByApplicationIdDefaultpermissionsByPermissionAppId(
    parameters: {
      applicationId: string;
      permissionAppId: string;
      body?: PermissionSet;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Application>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/defaultpermissions/{permissionAppId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      path = path.replace('{permissionAppId}', `${parameters['permissionAppId']}`);

      if (parameters['permissionAppId'] === undefined) {
        reject(new Error('Missing required  parameter: permissionAppId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthApplicationsByApplicationIdPolicies
   * @description /auth/applications/{applicationId}/policies
   * @param {string} applicationId - Insight2Profit AuthenticationService
   */
  getAuthApplicationsByApplicationIdPolicies(
    parameters: {
      applicationId: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Array<Policy>>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/policies';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthApplicationsByApplicationIdPolicies
   * @description /auth/applications/{applicationId}/policies
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthApplicationsByApplicationIdPolicies(
    parameters: {
      applicationId: string;
      body?: Policy;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/policies';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthApplicationsByApplicationIdPoliciesByPolicyName
   * @description /auth/applications/{applicationId}/policies/{policyName}
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {string} policyName - Insight2Profit AuthenticationService
   */
  deleteAuthApplicationsByApplicationIdPoliciesByPolicyName(
    parameters: {
      applicationId: string;
      policyName: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/policies/{policyName}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      path = path.replace('{policyName}', `${parameters['policyName']}`);

      if (parameters['policyName'] === undefined) {
        reject(new Error('Missing required  parameter: policyName'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthApplicationsByApplicationIdPoliciesByPolicyName
   * @description /auth/applications/{applicationId}/policies/{policyName}
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {string} policyName - Insight2Profit AuthenticationService
   */
  getAuthApplicationsByApplicationIdPoliciesByPolicyName(
    parameters: {
      applicationId: string;
      policyName: string;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, InsightServicesResponseWrapper<Policy>> | ResponseWithBody<400, MvcProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/policies/{policyName}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      path = path.replace('{policyName}', `${parameters['policyName']}`);

      if (parameters['policyName'] === undefined) {
        reject(new Error('Missing required  parameter: policyName'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#putAuthApplicationsByApplicationIdPoliciesByPolicyName
   * @description /auth/applications/{applicationId}/policies/{policyName}
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {string} policyName - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  putAuthApplicationsByApplicationIdPoliciesByPolicyName(
    parameters: {
      applicationId: string;
      policyName: string;
      body?: Policy;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/policies/{policyName}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      path = path.replace('{policyName}', `${parameters['policyName']}`);

      if (parameters['policyName'] === undefined) {
        reject(new Error('Missing required  parameter: policyName'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthApplicationsByApplicationIdProtectedproperties
   * @description /auth/applications/{applicationId}/protectedproperties
   * @param {string} applicationId - Insight2Profit AuthenticationService
   */
  getAuthApplicationsByApplicationIdProtectedproperties(
    parameters: {
      applicationId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Array<ProtectedProperty>>>
    | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/protectedproperties';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthApplicationsByApplicationIdProtectedproperties
   * @description /auth/applications/{applicationId}/protectedproperties
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthApplicationsByApplicationIdProtectedproperties(
    parameters: {
      applicationId: string;
      body?: ProtectedProperty;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/protectedproperties';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#putAuthApplicationsByApplicationIdProtectedpropertiesByPropertyId
   * @description /auth/applications/{applicationId}/protectedproperties/{propertyId}
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {string} propertyId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  putAuthApplicationsByApplicationIdProtectedpropertiesByPropertyId(
    parameters: {
      applicationId: string;
      propertyId: string;
      body?: ProtectedProperty;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/protectedproperties/{propertyId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      path = path.replace('{propertyId}', `${parameters['propertyId']}`);

      if (parameters['propertyId'] === undefined) {
        reject(new Error('Missing required  parameter: propertyId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthApplicationsByApplicationIdProtectedpropertiesByProtectedpropertyid
   * @description /auth/applications/{applicationId}/protectedproperties/{protectedpropertyid}
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {string} protectedPropertyId - Insight2Profit AuthenticationService
   */
  deleteAuthApplicationsByApplicationIdProtectedpropertiesByProtectedpropertyid(
    parameters: {
      applicationId: string;
      protectedPropertyId: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/protectedproperties/{protectedpropertyid}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      path = path.replace('{protectedPropertyId}', `${parameters['protectedPropertyId']}`);

      if (parameters['protectedPropertyId'] === undefined) {
        reject(new Error('Missing required  parameter: protectedPropertyId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthApplicationsByApplicationIdProtectedpropertiesByProtectedpropertyid
   * @description /auth/applications/{applicationId}/protectedproperties/{protectedpropertyid}
   * @param {string} applicationId - Insight2Profit AuthenticationService
   * @param {string} protectedPropertyId - Insight2Profit AuthenticationService
   */
  getAuthApplicationsByApplicationIdProtectedpropertiesByProtectedpropertyid(
    parameters: {
      applicationId: string;
      protectedPropertyId: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<ProtectedProperty>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{applicationId}/protectedproperties/{protectedpropertyid}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      path = path.replace('{protectedPropertyId}', `${parameters['protectedPropertyId']}`);

      if (parameters['protectedPropertyId'] === undefined) {
        reject(new Error('Missing required  parameter: protectedPropertyId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthApplicationsById
   * @description /auth/applications/{id}
   * @param {string} id - Insight2Profit AuthenticationService
   */
  deleteAuthApplicationsById(
    parameters: {
      id: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, void> | ResponseWithBody<400, MvcProblemDetails> | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthApplicationsById
   * @description /auth/applications/{id}
   * @param {string} id - Insight2Profit AuthenticationService
   */
  getAuthApplicationsById(
    parameters: {
      id: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Application>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthApplicationsByIdPermissions
   * @description /auth/applications/{id}/permissions
   * @param {string} id - Insight2Profit AuthenticationService
   */
  getAuthApplicationsByIdPermissions(
    parameters: {
      id: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Array<Permission>>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/permissions';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthApplicationsByIdPermissions
   * @description /auth/applications/{id}/permissions
   * @param {string} id - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthApplicationsByIdPermissions(
    parameters: {
      id: string;
      body?: Permission;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/permissions';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#putAuthApplicationsByIdPermissionsByPermissionId
   * @description /auth/applications/{id}/permissions/{permissionId}
   * @param {string} id - Insight2Profit AuthenticationService
   * @param {string} permissionId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  putAuthApplicationsByIdPermissionsByPermissionId(
    parameters: {
      id: string;
      permissionId: string;
      body?: Permission;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/permissions/{permissionId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{permissionId}', `${parameters['permissionId']}`);

      if (parameters['permissionId'] === undefined) {
        reject(new Error('Missing required  parameter: permissionId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthApplicationsByIdPermissionsByPermission
   * @description /auth/applications/{id}/permissions/{permission}
   * @param {string} id - Insight2Profit AuthenticationService
   * @param {string} permission - Insight2Profit AuthenticationService
   */
  deleteAuthApplicationsByIdPermissionsByPermission(
    parameters: {
      id: string;
      permission: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/permissions/{permission}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{permission}', `${parameters['permission']}`);

      if (parameters['permission'] === undefined) {
        reject(new Error('Missing required  parameter: permission'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthApplicationsByIdRoles
   * @description /auth/applications/{id}/roles
   * @param {string} id - Insight2Profit AuthenticationService
   */
  getAuthApplicationsByIdRoles(
    parameters: {
      id: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Array<Role>>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/roles';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthApplicationsByIdRoles
   * @description /auth/applications/{id}/roles
   * @param {string} id - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthApplicationsByIdRoles(
    parameters: {
      id: string;
      body?: Role;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/roles';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#putAuthApplicationsByIdRolesByRoleId
   * @description /auth/applications/{id}/roles/{roleId}
   * @param {string} id - Insight2Profit AuthenticationService
   * @param {string} roleId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  putAuthApplicationsByIdRolesByRoleId(
    parameters: {
      id: string;
      roleId: string;
      body?: Role;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/roles/{roleId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{roleId}', `${parameters['roleId']}`);

      if (parameters['roleId'] === undefined) {
        reject(new Error('Missing required  parameter: roleId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthApplicationsByIdRolesByRole
   * @description /auth/applications/{id}/roles/{role}
   * @param {string} id - Insight2Profit AuthenticationService
   * @param {string} role - Insight2Profit AuthenticationService
   */
  deleteAuthApplicationsByIdRolesByRole(
    parameters: {
      id: string;
      role: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/roles/{role}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{role}', `${parameters['role']}`);

      if (parameters['role'] === undefined) {
        reject(new Error('Missing required  parameter: role'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthApplicationsByIdRolesByRolePermissions
   * @description /auth/applications/{id}/roles/{role}/permissions
   * @param {string} id - Insight2Profit AuthenticationService
   * @param {string} role - Insight2Profit AuthenticationService
   */
  getAuthApplicationsByIdRolesByRolePermissions(
    parameters: {
      id: string;
      role: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Array<string>>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/roles/{role}/permissions';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{role}', `${parameters['role']}`);

      if (parameters['role'] === undefined) {
        reject(new Error('Missing required  parameter: role'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthApplicationsByIdRolesByRolePermissions
   * @description /auth/applications/{id}/roles/{role}/permissions
   * @param {string} id - Insight2Profit AuthenticationService
   * @param {string} role - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthApplicationsByIdRolesByRolePermissions(
    parameters: {
      id: string;
      role: string;
      body?: RolePermission;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/roles/{role}/permissions';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{role}', `${parameters['role']}`);

      if (parameters['role'] === undefined) {
        reject(new Error('Missing required  parameter: role'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#putAuthApplicationsByIdRolesByRolePermissions
   * @description /auth/applications/{id}/roles/{role}/permissions
   * @param {string} id - Insight2Profit AuthenticationService
   * @param {string} role - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  putAuthApplicationsByIdRolesByRolePermissions(
    parameters: {
      id: string;
      role: string;
      body?: RolePermission;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/roles/{role}/permissions';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{role}', `${parameters['role']}`);

      if (parameters['role'] === undefined) {
        reject(new Error('Missing required  parameter: role'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthApplicationsByIdRolesByRolePermissionsByPermission
   * @description /auth/applications/{id}/roles/{role}/permissions/{permission}
   * @param {string} id - Insight2Profit AuthenticationService
   * @param {string} role - Insight2Profit AuthenticationService
   * @param {string} permission - Insight2Profit AuthenticationService
   */
  deleteAuthApplicationsByIdRolesByRolePermissionsByPermission(
    parameters: {
      id: string;
      role: string;
      permission: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Application>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/roles/{role}/permissions/{permission}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      path = path.replace('{role}', `${parameters['role']}`);

      if (parameters['role'] === undefined) {
        reject(new Error('Missing required  parameter: role'));
        return;
      }

      path = path.replace('{permission}', `${parameters['permission']}`);

      if (parameters['permission'] === undefined) {
        reject(new Error('Missing required  parameter: permission'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthApplicationsByIdUsers
   * @description /auth/applications/{id}/users
   * @param {string} id - Insight2Profit AuthenticationService
   */
  getAuthApplicationsByIdUsers(
    parameters: {
      id: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Array<UserPermission>>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/applications/{id}/users';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthClients
   * @description /auth/clients
   */
  getAuthClients(
    parameters: {} & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Array<Client>>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthClients
   * @description /auth/clients
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthClients(
    parameters: {
      body?: Client;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, InsightServicesResponseWrapper<Client>> | ResponseWithBody<400, MvcProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthClientsByClientId
   * @description /auth/clients/{clientId}
   * @param {string} clientId - Insight2Profit AuthenticationService
   */
  deleteAuthClientsByClientId(
    parameters: {
      clientId: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, void> | ResponseWithBody<400, MvcProblemDetails> | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients/{clientId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthClientsByClientId
   * @description /auth/clients/{clientId}
   * @param {string} clientId - Insight2Profit AuthenticationService
   */
  getAuthClientsByClientId(
    parameters: {
      clientId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Client>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients/{clientId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#putAuthClientsByClientId
   * @description /auth/clients/{clientId}
   * @param {string} clientId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  putAuthClientsByClientId(
    parameters: {
      clientId: string;
      body?: Client;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Client>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients/{clientId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthClientsByClientIdApplications
   * @description /auth/clients/{clientId}/applications
   * @param {string} clientId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthClientsByClientIdApplications(
    parameters: {
      clientId: string;
      body?: Application;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Client>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients/{clientId}/applications';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthClientsByClientIdApplicationsByApplicationId
   * @description /auth/clients/{clientId}/applications/{applicationId}
   * @param {string} clientId - Insight2Profit AuthenticationService
   * @param {string} applicationId - Insight2Profit AuthenticationService
   */
  deleteAuthClientsByClientIdApplicationsByApplicationId(
    parameters: {
      clientId: string;
      applicationId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Client>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients/{clientId}/applications/{applicationId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthClientsByClientIdAttributes
   * @description /auth/clients/{clientId}/attributes
   * @param {string} clientId - Insight2Profit AuthenticationService
   */
  getAuthClientsByClientIdAttributes(
    parameters: {
      clientId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Array<ClientAttribute>>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients/{clientId}/attributes';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthClientsByClientIdAttributes
   * @description /auth/clients/{clientId}/attributes
   * @param {string} clientId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthClientsByClientIdAttributes(
    parameters: {
      clientId: string;
      body?: ClientAttribute;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Client>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients/{clientId}/attributes';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthClientsByClientIdAttributesByAttributeId
   * @description /auth/clients/{clientId}/attributes/{attributeId}
   * @param {string} clientId - Insight2Profit AuthenticationService
   * @param {string} attributeId - Insight2Profit AuthenticationService
   */
  deleteAuthClientsByClientIdAttributesByAttributeId(
    parameters: {
      clientId: string;
      attributeId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Client>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients/{clientId}/attributes/{attributeId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{attributeId}', `${parameters['attributeId']}`);

      if (parameters['attributeId'] === undefined) {
        reject(new Error('Missing required  parameter: attributeId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthClientsByClientIdUserlist
   * @description /auth/clients/{clientId}/userlist
   * @param {string} clientId - Insight2Profit AuthenticationService
   */
  getAuthClientsByClientIdUserlist(
    parameters: {
      clientId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Array<AuthorizationUser>>>
    | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients/{clientId}/userlist';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthClientsByClientIdUsers
   * @description /auth/clients/{clientId}/users
   * @param {string} clientId - Insight2Profit AuthenticationService
   */
  getAuthClientsByClientIdUsers(
    parameters: {
      clientId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Array<AuthorizationUser>>>
    | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/clients/{clientId}/users';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthGraphApplications
   * @description /auth/graph/applications
   */
  getAuthGraphApplications(
    parameters: {} & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Array<GraphApplication>>>
    | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/graph/applications';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthGraphApplicationsById
   * @description /auth/graph/applications/{id}
   * @param {string} id - Insight2Profit AuthenticationService
   */
  getAuthGraphApplicationsById(
    parameters: {
      id: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, GraphApplication>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/graph/applications/{id}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{id}', `${parameters['id']}`);

      if (parameters['id'] === undefined) {
        reject(new Error('Missing required  parameter: id'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthGraphUsers
   * @description /auth/graph/users
   * @param {string} email - Insight2Profit AuthenticationService
   * @param {string} displayName - Insight2Profit AuthenticationService
   */
  getAuthGraphUsers(
    parameters: {
      email?: string;
      displayName?: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Array<UserDTO>>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/graph/users';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      if (parameters['email'] !== undefined) {
        queryParameters['Email'] = parameters['email'];
      }

      if (parameters['displayName'] !== undefined) {
        queryParameters['DisplayName'] = parameters['displayName'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthGraphUsersByUserId
   * @description /auth/graph/users/{userId}
   * @param {string} userId - Insight2Profit AuthenticationService
   */
  getAuthGraphUsersByUserId(
    parameters: {
      userId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<UserDTO>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/graph/users/{userId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthPermissionsUsers
   * @description /auth/permissions/users
   * @param {} body - Insight2Profit AuthenticationService
   */
  //
  postAuthPermissionsUsers(
    parameters: {
      body?: PermissionRequest;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, AuthorizationResponse>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthPermissionsUsersByUserId
   * @description /auth/permissions/users/{userId}
   * @param {string} userId - Insight2Profit AuthenticationService
   */
  deleteAuthPermissionsUsersByUserId(
    parameters: {
      userId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, UserPermission>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthPermissionsUsersByUserId
   * @description /auth/permissions/users/{userId}
   * @param {string} userId - Insight2Profit AuthenticationService
   */
  getAuthPermissionsUsersByUserId(
    parameters: {
      userId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Array<ApplicationPermissionSet>>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthPermissionsUsersByUserIdApplicationsByAppIdPermissions
   * @description /auth/permissions/users/{userId}/applications/{appId}/permissions
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} appId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthPermissionsUsersByUserIdApplicationsByAppIdPermissions(
    parameters: {
      userId: string;
      appId: string;
      body?: Permission;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, UserPermission>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}/applications/{appId}/permissions';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{appId}', `${parameters['appId']}`);

      if (parameters['appId'] === undefined) {
        reject(new Error('Missing required  parameter: appId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthPermissionsUsersByUserIdApplicationsByAppIdPermissionsByPermission
   * @description /auth/permissions/users/{userId}/applications/{appId}/permissions/{permission}
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} appId - Insight2Profit AuthenticationService
   * @param {string} permission - Insight2Profit AuthenticationService
   */
  deleteAuthPermissionsUsersByUserIdApplicationsByAppIdPermissionsByPermission(
    parameters: {
      userId: string;
      appId: string;
      permission: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, UserPermission>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}/applications/{appId}/permissions/{permission}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{appId}', `${parameters['appId']}`);

      if (parameters['appId'] === undefined) {
        reject(new Error('Missing required  parameter: appId'));
        return;
      }

      path = path.replace('{permission}', `${parameters['permission']}`);

      if (parameters['permission'] === undefined) {
        reject(new Error('Missing required  parameter: permission'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthPermissionsUsersByUserIdApplicationsByAppIdPolicies
   * @description /auth/permissions/users/{userId}/applications/{appId}/policies
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} appId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthPermissionsUsersByUserIdApplicationsByAppIdPolicies(
    parameters: {
      userId: string;
      appId: string;
      body?: Policy;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, UserPermission>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}/applications/{appId}/policies';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{appId}', `${parameters['appId']}`);

      if (parameters['appId'] === undefined) {
        reject(new Error('Missing required  parameter: appId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthPermissionsUsersByUserIdApplicationsByAppIdPoliciesByPolicyname
   * @description /auth/permissions/users/{userId}/applications/{appId}/policies/{policyname}
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} appId - Insight2Profit AuthenticationService
   * @param {string} policyName - Insight2Profit AuthenticationService
   */
  deleteAuthPermissionsUsersByUserIdApplicationsByAppIdPoliciesByPolicyname(
    parameters: {
      userId: string;
      appId: string;
      policyName: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, void> | ResponseWithBody<400, MvcProblemDetails> | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}/applications/{appId}/policies/{policyname}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{appId}', `${parameters['appId']}`);

      if (parameters['appId'] === undefined) {
        reject(new Error('Missing required  parameter: appId'));
        return;
      }

      path = path.replace('{policyName}', `${parameters['policyName']}`);

      if (parameters['policyName'] === undefined) {
        reject(new Error('Missing required  parameter: policyName'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthPermissionsUsersByUserIdApplicationsByAppIdRoles
   * @description /auth/permissions/users/{userId}/applications/{appId}/roles
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} appId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthPermissionsUsersByUserIdApplicationsByAppIdRoles(
    parameters: {
      userId: string;
      appId: string;
      body?: Role;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, UserPermission>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}/applications/{appId}/roles';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{appId}', `${parameters['appId']}`);

      if (parameters['appId'] === undefined) {
        reject(new Error('Missing required  parameter: appId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthPermissionsUsersByUserIdApplicationsByAppIdRolesByRole
   * @description /auth/permissions/users/{userId}/applications/{appId}/roles/{role}
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} appId - Insight2Profit AuthenticationService
   * @param {string} role - Insight2Profit AuthenticationService
   */
  deleteAuthPermissionsUsersByUserIdApplicationsByAppIdRolesByRole(
    parameters: {
      userId: string;
      appId: string;
      role: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, void> | ResponseWithBody<400, MvcProblemDetails> | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}/applications/{appId}/roles/{role}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{appId}', `${parameters['appId']}`);

      if (parameters['appId'] === undefined) {
        reject(new Error('Missing required  parameter: appId'));
        return;
      }

      path = path.replace('{role}', `${parameters['role']}`);

      if (parameters['role'] === undefined) {
        reject(new Error('Missing required  parameter: role'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthPermissionsUsersByUserIdApplicationsByApplicationId
   * @description /auth/permissions/users/{userId}/applications/{applicationId}
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} applicationId - Insight2Profit AuthenticationService
   */
  getAuthPermissionsUsersByUserIdApplicationsByApplicationId(
    parameters: {
      userId: string;
      applicationId: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<Array<string>>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}/applications/{applicationId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthPermissionsUsersByUserIdApplicationsByApplicationIdPolicies
   * @description /auth/permissions/users/{userId}/applications/{applicationId}/policies
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} applicationId - Insight2Profit AuthenticationService
   */
  getAuthPermissionsUsersByUserIdApplicationsByApplicationIdPolicies(
    parameters: {
      userId: string;
      applicationId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, Response_getAuthPermissionsUsersByUserIdApplicationsByApplicationIdPolicies_200>
    | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}/applications/{applicationId}/policies';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthPermissionsUsersByUserIdApplicationsByApplicationIdRoles
   * @description /auth/permissions/users/{userId}/applications/{applicationId}/roles
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} applicationId - Insight2Profit AuthenticationService
   */
  getAuthPermissionsUsersByUserIdApplicationsByApplicationIdRoles(
    parameters: {
      userId: string;
      applicationId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, Response_getAuthPermissionsUsersByUserIdApplicationsByApplicationIdRoles_200>
    | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/permissions/users/{userId}/applications/{applicationId}/roles';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{applicationId}', `${parameters['applicationId']}`);

      if (parameters['applicationId'] === undefined) {
        reject(new Error('Missing required  parameter: applicationId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthUsers
   * @description /auth/users
   */
  getAuthUsers(
    parameters: {} & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<Array<AuthorizationUser>>>
    | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthUsers
   * @description /auth/users
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthUsers(
    parameters: {
      body?: AuthorizationUser;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<AuthorizationUser>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthUsersByUserId
   * @description /auth/users/{userId}
   * @param {string} userId - Insight2Profit AuthenticationService
   */
  deleteAuthUsersByUserId(
    parameters: {
      userId: string;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, void> | ResponseWithBody<400, MvcProblemDetails> | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users/{userId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#getAuthUsersByUserId
   * @description /auth/users/{userId}
   * @param {string} userId - Insight2Profit AuthenticationService
   */
  getAuthUsersByUserId(
    parameters: {
      userId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<AuthorizationUser>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users/{userId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthUsersByUserId
   * @description /auth/users/{userId}
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthUsersByUserId(
    parameters: {
      userId: string;
      body?: AuthorizationUser;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<AuthorizationUser>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users/{userId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#putAuthUsersByUserId
   * @description /auth/users/{userId}
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  putAuthUsersByUserId(
    parameters: {
      userId: string;
      body?: AuthorizationUser;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<AuthorizationUser>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users/{userId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthUsersByUserIdClients
   * @description /auth/users/{userId}/clients
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthUsersByUserIdClients(
    parameters: {
      userId: string;
      body?: AuthorizationClient;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<AuthorizationUser>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users/{userId}/clients';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthUsersByUserIdClientsByClientId
   * @description /auth/users/{userId}/clients/{clientId}
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} clientId - Insight2Profit AuthenticationService
   */
  deleteAuthUsersByUserIdClientsByClientId(
    parameters: {
      userId: string;
      clientId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<AuthorizationUser>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users/{userId}/clients/{clientId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#postAuthUsersByUserIdClientsByClientIdAttributes
   * @description /auth/users/{userId}/clients/{clientId}/attributes
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} clientId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  postAuthUsersByUserIdClientsByClientIdAttributes(
    parameters: {
      userId: string;
      clientId: string;
      body?: ClientAttributeValue;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<AuthorizationUser>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users/{userId}/clients/{clientId}/attributes';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#deleteAuthUsersByUserIdClientsByClientIdAttributesByAttributeId
   * @description /auth/users/{userId}/clients/{clientId}/attributes/{attributeId}
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} clientId - Insight2Profit AuthenticationService
   * @param {string} attributeId - Insight2Profit AuthenticationService
   */
  deleteAuthUsersByUserIdClientsByClientIdAttributesByAttributeId(
    parameters: {
      userId: string;
      clientId: string;
      attributeId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, InsightServicesResponseWrapper<AuthorizationUser>>
    | ResponseWithBody<400, MvcProblemDetails>
    | ResponseWithBody<404, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users/{userId}/clients/{clientId}/attributes/{attributeId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{attributeId}', `${parameters['attributeId']}`);

      if (parameters['attributeId'] === undefined) {
        reject(new Error('Missing required  parameter: attributeId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('DELETE', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name AuthService#putAuthUsersByUserIdClientsByClientIdAttributesByAttributeId
   * @description /auth/users/{userId}/clients/{clientId}/attributes/{attributeId}
   * @param {string} userId - Insight2Profit AuthenticationService
   * @param {string} clientId - Insight2Profit AuthenticationService
   * @param {string} attributeId - Insight2Profit AuthenticationService
   * @param {} body - Insight2Profit AuthenticationService
   */
  putAuthUsersByUserIdClientsByClientIdAttributesByAttributeId(
    parameters: {
      userId: string;
      clientId: string;
      attributeId: string;
      body?: ClientAttributeValue;
    } & CommonRequestOptions
  ): Promise<
    ResponseWithBody<200, InsightServicesResponseWrapper<AuthorizationUser>> | ResponseWithBody<400, MvcProblemDetails>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/auth/users/{userId}/clients/{clientId}/attributes/{attributeId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{userId}', `${parameters['userId']}`);

      if (parameters['userId'] === undefined) {
        reject(new Error('Missing required  parameter: userId'));
        return;
      }

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{attributeId}', `${parameters['attributeId']}`);

      if (parameters['attributeId'] === undefined) {
        reject(new Error('Missing required  parameter: attributeId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PUT', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }
}

export default AuthService;
